const DOMAINS = [
    'LANG',
    'ADV_TASK_TYPE',
    'AI_TIPO_ALIQUOTA',
    'AI_BISOGNO',
    'AI_RAMO_GARANZIA',
    'AI_RAMO_POLIZZA',
    'AI_TIPO_COPERTURA',
    'AI_STATO_PRODOTTO',
    'AI_MODALITA_RATINO',
    'AI_MODALITA_PROVV_PASSIVE',
    'AI_GRUPPO_RAMO',
    'AI_AMBITO_RAMO',
    'AI_FRAZIONAMENTO',
    'AI_DOCUMENT_CATEGORY',
    'AI_TIPO_CONTRAENTE',
    'AI_PAGAMENTO',
    'AI_TIPO_OPERAZIONE',
    'AI_TIPO_FONDO',
    'COD_DIVPORT',
    'AI_QUESTIONARIO_TYPE',
    'LISTA_RISCHIO_LLOYDS',
    'AI_DURATA',
    'AI_SCONTO',
    'AI_PRINT_DOCUMENT_TYPE',
    'FIRMA_DIGITALE',
    'TIPO_AUTENTICAZIONE',
    'AI_TIPO_PROPOSTA',

];


export default DOMAINS;